import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "Miscellaneous Private Buses (Kolkata and Howrah)";

const MiscellaneousPrivateBusesKolkataHowrah = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the unnumbered RTA and STA permit buses which are
          commonly known by their end destination names. They may or may not be
          express buses RTA ones may be blue-yellow (or otherwise), STA ones
          usually have white colour with thin red lines (with exceptions).
        </p>

        <p className="my-4">
          Here we also list the privately operated AC bus routes. Most of them
          were earlier operated in partnership with the government. Recently
          privately owned AC buses are in operation as well.
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default MiscellaneousPrivateBusesKolkataHowrah;
